<template>
    <div class="loginWrap_form">
        <div class="loginWrap_form_top">
            <div class="loginWrap_hidden_logo">
                <a href="/">
                    <IconLogo />
                </a>
            </div>

            <a class="loginWrap_buttonBack" :href="$page.props.home_url ?? '/'">
                <IconArrowBack />
                <span>Back to the home page</span>
            </a>
            <h1>Welcome back!</h1>
            <LoginForm />
        </div>
        <div class="loginWrap_form_bottom">
            <p>
                Don't have an account yet?
                <Link href="/register">Register</Link>
            </p>
        </div>
    </div>
</template>

<script lang="ts">
import MainLayout from '@/layouts/MainLayout.vue';
import SideLayout from '@/layouts/SideLayout.vue';

export default {
    layout: [MainLayout, SideLayout],
};
</script>

<script setup lang="ts">
import LoginForm from '@/components/LoginForm.vue';
import IconArrowBack from '@/components/icons/IconArrowBack.vue';
import IconLogo from '@/components/icons/IconLogo.vue';
import { Link } from '@inertiajs/vue2';
</script>
